/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "styled-components";
import StepLabel from "@material-ui/core/StepLabel";

const StyledStepLabel = styled((props) => <StepLabel {...props} />)`
  ${({ theme }) => `
  `}
`;

export { StyledStepLabel };
